import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useStaticQuery, graphql, Script } from 'gatsby';
import Helmet from 'react-helmet';
import { StickyProvider } from 'react-stickup';

import Header from './Header';
import Footer from './Footer';

import '../styles/styles.scss';
function Layout({ children, showNewBG, disableLoader }) {
  const [isContactActive, setContactActive] = useState(false);

  const [loading, setLoading] = useState(!disableLoader);

  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `);

  const clickHandler = useCallback((e) => {
    if (
      e.target.nodeName === 'A' &&
      new URL(e.target.href).hash === '#contact'
    ) {
      e.preventDefault();
      e.stopPropagation();

      const el = e.target.closest('a');

      setContactActive({ formType: el.dataset.source, title: el.innerText });
    }
  }, []);

  useEffect(() => {
    window.addEventListener('click', clickHandler);

    return () => window.removeEventListener('click', clickHandler);
  }, []);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setLoading(false);
    }, 1500);

    return () => {
      clearTimeout(timeout);
    };
  }, []);

  return (
    <>
      <Helmet>
        <link rel="preconnect" href="https://fonts.gstatic.com" />
        <link
          href="https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;700&display=swap"
          rel="stylesheet"
        />
        <link
          rel="stylesheet"
          type="text/css"
          // eslint-disable-next-line react/no-unknown-property
          charset="UTF-8"
          href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css"
        />
      </Helmet>
      <div
        style={{
          position: 'fixed',
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
          zIndex: 9999999999,
          display: loading ? 'flex' : 'none',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: '#fff',
          transition: 'all 2ms',
        }}>
        <img src="/img/algobulls-logo.svg" alt="AlgoBulls logo" width="130px" />
      </div>
      <StickyProvider>
        <Header
          siteTitle={data.site.siteMetadata?.title || `Title`}
          isContactActive={isContactActive}
          setContactActive={setContactActive}
        />
        <main
          style={
            showNewBG
              ? {
                  backgroundImage: 'url(/img/inner-hero-build.svg)',
                  backgroundRepeat: 'repeat-x',
                }
              : {}
          }>
          {children({ setContactActive })}
        </main>
        <Script src="https://app.algobulls.com/chatbot.js" async />
        {/* <PromptCTA /> */}
        <Footer setContactActive={setContactActive} />
      </StickyProvider>
    </>
  );
}

Layout.propTypes = {
  children: PropTypes.func.isRequired,
  showNewBG: PropTypes.bool,
  disableLoader: PropTypes.bool,
};

export default Layout;
